<div>
  <app-return-trend-by-country-filter *ngIf="years"
    [years]="years"
    [categories]="categories"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)"
  ></app-return-trend-by-country-filter>
  <mat-divider></mat-divider>
  <app-return-trend-by-country-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [countries]="countries"
    [data]="data">
  </app-return-trend-by-country-bar-chart>
</div>
